import { render, staticRenderFns } from "./OnboardingDenver.vue?vue&type=template&id=a9d8d252"
import script from "./OnboardingDenver.vue?vue&type=script&lang=js"
export * from "./OnboardingDenver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports